module.exports = __webpack_public_path__ + "static/img/backup-icon.ad2bf7f8.png";